/* eslint-disable unicorn/no-negated-condition */
/* eslint-disable unicorn/prefer-number-properties */
/* eslint-disable @typescript-eslint/array-type */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable unicorn/prevent-abbreviations */
/* eslint-disable unicorn/consistent-function-scoping */
/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable prettier/prettier */
import isNil from 'lodash/isNil';
import omit from 'lodash/omit';
import omitBy from 'lodash/omitBy';

import {
  ClaimNumber,
  EIncludeExcludeKeys,
  EIncludeExcludeValue,
  LegalDetailsKeys,
  LegalDetailsPreparatorVariantsKey,
  StaticPropertyKey,
  YesNoVariantsKey,
} from '@bvi/api-interfaces/entity/case-property';
import { AdditionalFilterParameter } from '@bvi/api-interfaces/request/case';

import { isSyntheticJobTitleOption } from '../prepend-job-title-bulk-options';
import { isSyntheticOrganizationTypeOption } from '../prepend-organization-type-bulk-options';
import { ISearchFormDataSchema } from '../types';

export const mapFormDataToSubmit = (data: ISearchFormDataSchema) => {
  const preparatorValue =
    data[LegalDetailsKeys.PREPARATOR] === YesNoVariantsKey.YES
      ? [LegalDetailsPreparatorVariantsKey.DENIED_ABUSE]
      : [
        LegalDetailsPreparatorVariantsKey.ADMITTED_ABUSE,
        LegalDetailsPreparatorVariantsKey.CONVICTED,
        LegalDetailsPreparatorVariantsKey.DECEASED_WHEN_ACCUSED,
        LegalDetailsPreparatorVariantsKey.OTHERWISE_DEEMED_GUILTY,
      ];
  const classActionValue =
    data[EIncludeExcludeKeys.CLASS_ACTION_NAME] === EIncludeExcludeValue.YES
      ? EIncludeExcludeValue.YES
      : null;
  const bankruptcyValue =
    data[EIncludeExcludeKeys.BANKRUPTCY_NAME] === EIncludeExcludeValue.YES
      ? EIncludeExcludeValue.YES
      : null;
  const compensationValue =
    data[EIncludeExcludeKeys.COMPENSATION_REDRESS_NAME] ===
      EIncludeExcludeValue.YES
      ? EIncludeExcludeValue.YES
      : null;

  const result = {
    ...omit(data, [
      'excludelevel1',
      'excludelevel2',
      'excludelevel3',
      'excludelevel4',
      'excludelevel5',
    ]),
    [StaticPropertyKey.COUNTRY]: data[StaticPropertyKey.COUNTRY]?.map(
      (item) => item.id,
    ),
    [StaticPropertyKey.REGION]: data[StaticPropertyKey.REGION]?.map(
      (item) => item.id,
    ),
    [StaticPropertyKey.STATE]: data[StaticPropertyKey.STATE]?.map(
      (item) => item.id,
    ),
    [StaticPropertyKey.ORGANIZATION]: data[StaticPropertyKey.ORGANIZATION]?.id,
    ...(data[AdditionalFilterParameter.EXCLUDE_ORGANIZATION] &&
    data[StaticPropertyKey.ORGANIZATION]?.id != null
      ? { [AdditionalFilterParameter.EXCLUDE_ORGANIZATION]: true }
      : {}),
    [StaticPropertyKey.DIOCESE]: data[StaticPropertyKey.DIOCESE]?.id,
    ...(data[AdditionalFilterParameter.EXCLUDE_SUBSIDIARY] &&
    data[StaticPropertyKey.DIOCESE]?.id != null
      ? { [AdditionalFilterParameter.EXCLUDE_SUBSIDIARY]: true }
      : {}),
    [StaticPropertyKey.ORGANIZATION_TYPE]: data[
      StaticPropertyKey.ORGANIZATION_TYPE
    ]
      ?.filter((item) => !isSyntheticOrganizationTypeOption(item))
      .map((item) => item.id),
    [StaticPropertyKey.EXCEPTION]: data[StaticPropertyKey.EXCEPTION]?.map(
      (item) => item.id,
    ),
    [StaticPropertyKey.ORDER]: data[StaticPropertyKey.ORDER]?.map(
      (item) => item.id,
    ),
    [StaticPropertyKey.LIABILITY_DEFENSES]: data[
      StaticPropertyKey.LIABILITY_DEFENSES
    ]?.map((item) => item.id),
    [LegalDetailsKeys.PREPARATOR]: data[LegalDetailsKeys.PREPARATOR]
      ? preparatorValue
      : null,
    [StaticPropertyKey.RESOLUTION_TYPE]: data[
      StaticPropertyKey.RESOLUTION_TYPE
    ]?.map((item) => item.id),
    [StaticPropertyKey.JOB_TITLE]: data[StaticPropertyKey.JOB_TITLE]
      ?.filter((item) => !isSyntheticJobTitleOption(item))
      .map((item) => item.id),
    [StaticPropertyKey.PERPETRATOR]: data[StaticPropertyKey.PERPETRATOR]?.map(
      (item) => item.id,
    ),
    [EIncludeExcludeKeys.CLASS_ACTION_NAME]: data[
      EIncludeExcludeKeys.CLASS_ACTION_NAME
    ]
      ? classActionValue
      : null,
    [EIncludeExcludeKeys.BANKRUPTCY_NAME]: data[
      EIncludeExcludeKeys.BANKRUPTCY_NAME
    ]
      ? bankruptcyValue
      : null,
    [EIncludeExcludeKeys.COMPENSATION_REDRESS_NAME]: data[
      EIncludeExcludeKeys.COMPENSATION_REDRESS_NAME
    ]
      ? compensationValue
      : null,
    [ClaimNumber.NAME]: data[ClaimNumber.NAME] ?? null,
    [AdditionalFilterParameter.MAX_SEVERITY_LEVEL]:
      data[AdditionalFilterParameter.MAX_SEVERITY_LEVEL] === '' ||
      data[AdditionalFilterParameter.MAX_SEVERITY_LEVEL] == null
        ? null
        : data[AdditionalFilterParameter.MAX_SEVERITY_LEVEL],
    [AdditionalFilterParameter.AMOUNT_LOW]:
      data[AdditionalFilterParameter.AMOUNT_LOW] === '' ||
      data[AdditionalFilterParameter.AMOUNT_LOW] == null
        ? null
        : data[AdditionalFilterParameter.AMOUNT_LOW],
    [AdditionalFilterParameter.AMOUNT_HIGH]:
      data[AdditionalFilterParameter.AMOUNT_HIGH] === '' ||
      data[AdditionalFilterParameter.AMOUNT_HIGH] == null
        ? null
        : data[AdditionalFilterParameter.AMOUNT_HIGH],
  };

  return omitBy(result, (property) => isNil(property));
};
